module.exports = __webpack_public_path__ + "static/media/rewards.0e369618.svg";